<ng-template #contentRGPD let-modal class="modal-rgpf p-3">
    <div class="modal-header container border-0 pt-3">

        <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-0">

        <div class="p-3 text-center">
            <h4>DONNÉES PERSONNELLES
            </h4>
        </div>
        <div class="row p-3">
            <div class="infos-item">
                <div class="form-bloc" *ngIf="userInfo.type.id !== 5">
                    <fieldset class="field-item field-checkbox field-newsletter">
                        <div class="css3-checkbox">
                            <input type="checkbox" id="accept-newsletter" value="1" name="newsletter"
                                [(ngModel)]="userInfo.newsletter" [checked]="userInfo.newsletter">
                        </div>
                        <label for="accept-newsletter">J’accepte de recevoir la newsletter The Door Man</label>
                    </fieldset>
                    <fieldset class="field-item field-checkbox field-newsletter" *ngIf="isCreate">
                        <div class="css3-checkbox">
                            <input type="checkbox" id="souhaite-contacter" value="1" name="waitForContact"
                                [(ngModel)]="userInfo.waitForContact">
                        </div>
                        <label for="souhaite-contacter">Je souhaité être contacté par un Conseiller The Door
                            Man</label>
                    </fieldset>
                    <fieldset class="field-item field-checkbox field-newsletter">
                        <div class="css3-checkbox">
                            <input type="checkbox" id="accept-rgpdoffre" value="1" name="rgpdoffre"
                                [(ngModel)]="userInfo.rgpdoffre" [checked]="userInfo.rgpdoffre">
                        </div>
                        <label style="color:red;" for="accept-rgpdoffre">J’ACCEPTE DE RECEVOIR DES EMAILS LIES A MES
                            BIENS, VISITES, COMPTE-RENDU, OFFRES D'ACHAT</label>
                    </fieldset>
                    <fieldset class="field-item field-checkbox field-newsletter">
                        <div class="css3-checkbox">
                            <input type="checkbox" id="accept-rgpdpartenaire" value="1" name="rgpdpartenaire"
                                [(ngModel)]="userInfo.rgpdpartenaire" [checked]="userInfo.rgpdpartenaire">
                        </div>
                        <label for="accept-rgpdpartenaire">J’accepte de bénéficier des offres des partenaires
                            commerciaux de THE DOOR MAN</label>
                    </fieldset>
                    <fieldset class="field-item field-checkbox field-newsletter">
                        <div class="css3-checkbox">
                            <input type="checkbox" id="accept-rgpdemail" value="1" name="rgpdemail"
                                [(ngModel)]="userInfo.rgpdemail" [checked]="userInfo.rgpdemail">
                        </div>
                        <label style="color:red;" for="accept-rgpdemail">J’accepte de rester informé par e-mail de
                            l’actualité de THE
                            DOOR MAN</label> <i style="font-size: 11px;">( vous ne recevez pas de mail d'actualité
                            de la part The Door Man si vous laissez cette case décochée )</i>
                    </fieldset>
                    <fieldset class="field-item field-checkbox field-termes">
                        <div class="css3-checkbox">
                            <input type="checkbox" id="accept-termes" name="condition"
                                (click)="updateValue(conditionTerms)" #conditionTerms value="1"
                                [(ngModel)]="userInfo.condition" [checked]="userInfo.condition == true"
                                [required]="!isPartner">
                        </div>
                        <label style="color:red;" for="accept-termes">J’ai lu et j’accepte les termes de The Door
                            Man sur <a (click)="showinfoRGPD()">les données
                                personnelles</a>*</label>
                    </fieldset>
                </div>
            </div>
            <div class="btn-action">
                <input class="btn btn-creercompte" type="submit"
                    [value]=" isCreate ? 'Créer mon compte' : 'Enregistrer'" id="creercompte-form-modal"
                    (click)="onUserCreate(userInfo, isCreate, true)" [disabled]="invalidCondition">
            </div>
        </div>
    </div>
</ng-template>

<app-modal-info-rgpd *ngIf="showInfoRGPD"></app-modal-info-rgpd>
